// index.js (complete, corrected)
import React, { useEffect, useRef, useCallback } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter, Routes, Route, useNavigate, useLocation, Navigate, Outlet } from "react-router-dom"; 
import Swal from "sweetalert2";

import App from "./App"; 
import ManageStudents from "./manageStudents"; 
import ManageTeachers from "./manageTeachers"; 
import AddFamily from "./addFamily"; 
import AddFamilyCSV from "./addFamilyCSV"; 
import AddStudentsCSV from "./addStudentsCSV"; 
import AddTeachersCSV from "./addTeachersCSV"; 
import AddStudents from "./addStudent"; 
import SoloStudents from "./soloStudent"; 
import FamilyStudents from "./familyStudent"; 
import EditStudentsData from "./editStudentsData"; 
import EditStudent from "./EditStudent"; 
import StdSections from "./stdSections"; 
import ManageSections from "./manageSections"; 
import ViewSections from "./viewSections"; 
import AddTeacher from "./addTeacher"; 
import EditTeachersData from "./editTeachersData"; 
import EditTeacher from "./EditTeacher"; 
import ManageClassesAttendance from "./manageClassesAttendance"; 
import ClassesAttendance from "./classesAttendance"; 
import ManageClassesTests from "./manageClassesTests"; 
import ClassesTests from "./ClassesTests"; 
import TestRecords from "./TestRecordsScreen.js";
import ExamRecords from "./ExamRecordsScreen.js";
import ViewTestRecords from "./viewTestRecordsScreen.js";
import ViewExamRecords from "./ViewExamRecords.js";
import ManageClassesExams from "./manageClassesExams"; 
import ClassesExams from "./ClassesExams"; 
import Accounts from "./Finance";
import TestSheetSampleHome from "./TestSheetSampleHome";
import SPCSTS from "./PrintTestSheet";
import SPCSES from "./PrintExamSheet";
import SetupAccounts from "./SetupAccounts";
import SetupAccountsFaEx from "./SetupAccountsFaEx";
import ApplySoloStdFee from "./ApplySoloStdFee";
import ApplyFamStdFee from "./ApplyFamStdFee";
import ForgetStudent from "./ForgetStudent.js";
import ForgetStudentFC from "./ForgetStudentFamilyCode.js";
import PaySoloStdFee from "./PaySoloStdFee";
import PayFamStdFee from "./PayFamStdFee";
import RMS from "./RMS.js";
import ImsDash from "./ImsDashboard.js";
import WhatsAppManager from "./WhatsAppSenderModal.js";
import ChatScreen from "./ChatScreen.js";  
import BroadcastScreen from "./BroadcastScreen.js"; // 👈 NEW IMPORT
import MakeResults from "./MakeResults";
import ClasswiseStudents from "./ClasswiseStudents.js";
import SubjectManagement from "./SubjectManagement.js";
import AttendanceRecords from "./AttendanceRecords.js";
import FeeDefaulters from "./FeeDefaulters.js";
import SampleRC from "./sampleRC.js";
import reportWebVitals from "./reportWebVitals";
import SecondAss from "./SecondAss.js";
import Dashboard from "./dashboard.js";
import Ourusers from "./users.js";

// ============================================================
//  🤖 AI VOICE CONTROLLER (SONU BRIDGE)
// ============================================================
const sonuRoutes = {
  "nav_whatsapp_manager": "/WhatsAppManager",
  "nav_inventory_dashboard": "/Inventory Management Dashboard",
  "nav_our_users": "/Our Users",
  "nav_manage_students": "/manage-students",
  "nav_add_solo_student": "/soloStudent",
  "nav_add_family_student": "/familyStudent",
  "nav_add_family": "/Family-Form",
  "nav_add_students_csv": "/addStudentsCSV",
  "nav_add_family_csv": "/Family-Form-CSV",
  "nav_edit_students": "/Edit-Students-Data",
  "nav_manage_sections": "/manageSections",
  "nav_add_sections": "/addSections",
  "nav_classwise_students": "/All-Students",
  "nav_manage_teachers": "/manage-Teachers",
  "nav_add_teacher": "/Add-Teacher",
  "nav_add_teachers_csv": "/addTeachersCSV",
  "nav_edit_teachers": "/Edit-Teachers-Data",
  "nav_subject_management": "/Subject Management",
  "nav_classes_attendance": "/Classes-Attendance",
  "nav_manage_classes_attendance": "/Manage-Classes-Attendance",
  "nav_attendance_records": "/Attendance Records",
  "nav_manage_tests": "/Manage-Classes-Tests",
  "nav_test_records": "/test-records",
  "nav_classes_test_sheet": "/Classes-Test-Sheet",
  "nav_manage_exams": "/Manage-Classes-Exams",
  "nav_exam_records": "/exam-records",
  "nav_exam_marks_sheet": "/Exam-Marks-Sheet",
  "nav_result_dashboard": "/Result Management Dashboard",
  "nav_make_results": "/Make-Results",
  "nav_second_assessment": "/Second Assessment",
  "nav_accounts": "/Accounts",
  "nav_accounts_setup": "/Accounts-Setup",
  "nav_setup_fee_expenses": "/Setup-Fee-Expenses",
  "nav_fee_defaulters": "/Fee Defaulters",
  "nav_apply_fee_solo": "/Fee-ApplyTo-Solo-Student",
  "nav_apply_fee_family": "/Fee-ApplyTo-Family-Student",
  "nav_pay_fee_solo": "/Fee-PaymentOf-Solo-Student",
  "nav_pay_fee_family": "/Fee-PaymentOf-Family-Student"
};

const GlobalSonuBridge = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const action = searchParams.get('sonu_action');

    if (!action) return;

    console.log("🤖 Sonu Central Controller activated for:", action);

    if (action === 'autologin' || action === 'nav_login') {
      const loginButton = document.getElementById('login-button');
      if (loginButton) {
        console.log("🤖 Sonu is logging you in...");
        loginButton.click();
      } else {
        console.warn("Sonu couldn't find the login button!");
      }
      navigate(location.pathname, { replace: true });
    } 
    else if (sonuRoutes[action]) {
      navigate(sonuRoutes[action]);
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);

  return null; 
};

// ============================================================
// 🔒 PROTECTED ROUTE & IDLE TIMEOUT MANAGER
// ============================================================
const ProtectedLayout = () => {
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");
  const timerRef = useRef(null);
  const IDLE_TIMEOUT = 5 * 60 * 1000; // 5 minutes in milliseconds

  const handleLogout = useCallback((isTimeout = false) => {
    // Clear storage
    localStorage.removeItem("authToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("sessionExpiry");
    
    if (isTimeout) {
      Swal.fire({
        title: "Session Expired",
        text: "You have been automatically logged out due to 5 minutes of inactivity.",
        icon: "info",
        confirmButtonColor: "#3498db"
      });
    }
    
    // Redirect to login
    navigate("/", { replace: true });
  }, [navigate]);

  // Handle User Activity & Auto Logout
  useEffect(() => {
    if (!token) return;

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => handleLogout(true), IDLE_TIMEOUT);
    };

    // Events to monitor for activity
    const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart'];
    const activityHandler = () => resetTimer();

    // Start timer on mount
    resetTimer();
    
    // Attach event listeners
    events.forEach(e => window.addEventListener(e, activityHandler));

    // Cleanup listeners on unmount
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
      events.forEach(e => window.removeEventListener(e, activityHandler));
    };
  }, [token, handleLogout]);

  // Synchronize logouts across multiple browser tabs
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === "authToken" && !e.newValue) {
        navigate("/", { replace: true });
      }
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [navigate]);

  // Guard Clause: If there is no token, redirect to the root (login page)
  if (!token) {
    return <Navigate to="/" replace />;
  }

  // Render the protected page if token exists
  return <Outlet />;
};
// ============================================================

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      
      {/* 🚀 INJECTING THE BRIDGE DIRECTLY INSIDE THE ROUTER 🚀 */}
      <GlobalSonuBridge />

      <Routes>
        {/* PUBLIC ROUTE: Only the Login page is freely accessible */}
        <Route path="/" element={<App />} /> 
        
        {/* PROTECTED ROUTES: Wrapped in the auth & idle timer layout */}
        <Route element={<ProtectedLayout />}>
            <Route path="/Dashboard" element={<Dashboard />} />
            <Route path="/Our Users" element={<Ourusers />} />

            <Route path="/manage-students" element={<ManageStudents />} />
            <Route path="/manage-Teachers" element={<ManageTeachers />} />
            <Route path="/Family-Form" element={<AddFamily />} />
            <Route path="/Family-Form-CSV" element={<AddFamilyCSV />} />
            <Route path="/addStudent" element={<AddStudents />} />
            <Route path="/soloStudent" element={<SoloStudents />} />
            <Route path="/familyStudent" element={<FamilyStudents />} />
            <Route path="/addSections" element={<StdSections />} />
            <Route path="/manageSections" element={<ManageSections />} />
            <Route path="/viewSections" element={<ViewSections />} />
            <Route path="/addStudentsCSV" element={<AddStudentsCSV />} />
            <Route path="/addTeachersCSV" element={<AddTeachersCSV />} />
            <Route path="/Edit-Students-Data" element={<EditStudentsData />} />
            <Route path="/Edit-Student-Panel" element={<EditStudent />} />
            <Route path="/Add-Teacher" element={<AddTeacher />} />
            <Route path="/Edit-Teachers-Data" element={<EditTeachersData />} />
            <Route path="/Edit-Teacher-Panel" element={<EditTeacher />} />
            <Route path="/All-Students" element={<ClasswiseStudents />} />
            <Route path="/Subject Management" element={<SubjectManagement />} />
            <Route path="/Attendance Records" element={<AttendanceRecords />} />
            <Route path="/Fee Defaulters" element={<FeeDefaulters />} />
            <Route path="/Sample-RC" element={<SampleRC />} />
            <Route path="/Result Management Dashboard" element={<RMS />} />
            <Route path="/Second Assessment" element={<SecondAss/>} />
            <Route path="/Inventory Management Dashboard" element={<ImsDash/>} />

            {/* ===== WhatsApp, Chat & Broadcast Routes ===== */}
            <Route path="/WhatsAppManager" element={<WhatsAppManager />} />
            <Route path="/chat/:id" element={<ChatScreen />} />   
            <Route path="/Inbox" element={<ChatScreen />} />
            {/* 👇 NEW ROUTE ADDED FOR BROADCAST SCREEN 👇 */}
            <Route path="/broadcast" element={<BroadcastScreen />} />

            <Route path="/Manage-Classes-Attendance" element={<ManageClassesAttendance />} />
            <Route path="/Classes-Attendance" element={<ClassesAttendance />} />
            <Route path="/Manage-Classes-Tests" element={<ManageClassesTests />} />
            <Route path="/test-records" element={<TestRecords />} />
            <Route path="/exam-records" element={<ExamRecords />} />
            <Route path="/ViewTestRecords/:testId" element={<ViewTestRecords />} />
            <Route path="/view-exam-records/:examId" element={<ViewExamRecords />} />
            <Route path="/Classes-Test-Sheet" element={<ClassesTests />} />
            <Route path="/Manage-Classes-Exams" element={<ManageClassesExams />} />
            <Route path="/Exam-Marks-Sheet" element={<ClassesExams />} />
            <Route path="/Accounts" element={<Accounts />} />
            <Route path="/Test-Sheet-Sample-Home" element={<TestSheetSampleHome />} />
            <Route path="/Print-Test-Sheet-Sample" element={<SPCSTS />} />
            <Route path="/Print-Exam-Sheet-Sample" element={<SPCSES />} />
            <Route path="/Accounts-Setup" element={<SetupAccounts />} />
            <Route path="/Setup-Fee-Expenses" element={<SetupAccountsFaEx />} />
            <Route path="/Fee-ApplyTo-Solo-Student" element={<ApplySoloStdFee />} />
            <Route path="/Fee-ApplyTo-Family-Student" element={<ApplyFamStdFee />} />
            <Route path="/Forget-Student-ID" element={<ForgetStudent />} />
            <Route path="/Forget-Family-Code" element={<ForgetStudentFC />} />
            <Route path="/Fee-PaymentOf-Solo-Student" element={<PaySoloStdFee />} />
            <Route path="/Fee-PaymentOf-Family-Student" element={<PayFamStdFee />} />
            <Route path="/Make-Results" element={<MakeResults />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();